import UsersTab from './usersTab.container.js';

export default UsersTab;
